/**Dependencies */
import React, { useEffect, useState } from "react";

// Styles
import { Accordion, Button, Col, Form, Row } from "react-bootstrap";
import { FaChild, FaRegCalendarAlt } from "react-icons/fa";
import { IoMoonOutline } from "react-icons/io5";
import { IoMdBed } from "react-icons/io";
import { FaPerson } from "react-icons/fa6";
import {
  Currency,
  fetchMarkup,
  FormatCancellationPolicies,
  FormatDate,
  totalPrices,
} from "../helpers";
import useForm from "../hooks/useForm";
import { getHotelesRate } from "../services/searchService";
import { ModalTerminos } from "../components/ModalTerminos";
import { validateCupon } from "../services/markupService";
import Swal from "sweetalert2";
import { getActivePDP, getCodigoPaisesLada } from "../services/checkoutService";
import { bbvaVpos, ConektaVpos, OpenpayVpos } from "../services/Booking";
import { useNavigate } from "react-router-dom";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
export const Checkout = () => {
  const [dataCart, setDataCart] = useState(
    JSON.parse(sessionStorage.getItem("datosReserva"))
  );
  const [totalReserva, setTotalReserva] = useState(0);
  const [totalHospedaje, setTotalHospedaje] = useState(0);
  const [totalPax, setTotalPax] = useState([]);
  const [totalRoomsData, setTotalRoomsData] = useState([]);
  const [nights, setNights] = useState(0);
  const [validForm, setValidForm] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [cuponCode, setCuponCode] = useState("");
  const [validatedCupon, setValidatedCupon] = useState("");
  const [descount, setDescount] = useState(0);
  const [codeCountries, setCodeCountries] = useState([]);
  const [urlPDP, setUrlPDP] = useState("");
  const [markup, setMarkup] = useState("");
  const [pdp, setPdp] = useState();
  const navigate = useNavigate();
  let requestPDP;
  let initialState = {
    name: "",
    lastName: "",
    phone: "",
    email: "",
    responsables: [],
    comentarios: "",
    lada: "+52",
  };
  const validations = {
    name: {
      test: (value) => /^[a-zA-Z\s]*$/.test(value),
      message: "El nombre solo puede contener letras y espacios.",
    },
    lastName: {
      test: (value) => /^[a-zA-Z\s]*$/.test(value),
      message: "El apellido solo puede contener letras y espacios.",
    },
    phone: {
      test: (value) => /^\d*$/.test(value),
      message: "El teléfono solo puede contener números.",
    },
  };

  const { formData, handleChange, handleSubmit, setFormData } = useForm(
    initialState,
    validations
  );

  const formValid = () => {
    const camposTextoLlenos = Object.entries(formData)
      .filter(([key, value]) => typeof value === "string")
      .every(([_, value]) => value.trim() !== "");

    const responsablesValidos = Array.isArray(formData.responsables)
      ? formData.responsables.every(
          (res) =>
            typeof res.name === "string" &&
            res.name.trim() !== "" &&
            typeof res.lastName === "string" &&
            res.lastName.trim() !== ""
        )
      : true;

    return camposTextoLlenos && responsablesValidos;
  };

  const handleValidation = () => {
    if (formValid()) {
      setValidForm(true);
      const request = construirRequestPDP();
      vposPago(request);
    } else {
      Swal.fire({
        title: "Existen campos vacios",
        text: "Por favor, completa todos los campos del formulario para poder realizar la reserva.",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "w-100 text-light btn-blue",
        },
      });
      setValidForm(false);
    }
  };

  useEffect(() => {
    if (dataCart?.hospedaje?.length > 0) {
      const inicial = dataCart.hospedaje.map(() => ({
        name: "",
        lastName: "",
      }));
      setFormData((prevData) => ({
        ...prevData,
        responsables: inicial,
      }));
    }
  }, [dataCart?.hospedaje]);

  useEffect(() => {
    const hospedaje = Number(precioHospedajes());
    if (precioHospedajes() > 0) {
      if (descount?.valid) {
        const total = hospedaje - descount?.descuento;
        setTotalReserva(total);
      } else {
        setTotalReserva(hospedaje);
        setTotalHospedaje(hospedaje);
      }
    } else {
      setTotalReserva(hospedaje);
      setTotalHospedaje(hospedaje);
    }
  }, [dataCart, descount]);

  useEffect(() => {
    setTotalPax([totalAdults(), totalMinors(), totalRooms()]);
    setTotalRoomsData(totalRooms());
  }, [dataCart]);
  useEffect(() => {
    const fetchMarkupPanel = async () => {
      try {
        const markupData = await fetchMarkup();
        setMarkup(markupData.markup);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchMarkupPanel();
  }, []);

  useEffect(() => {
    if (dataCart) {
      const nights = dataCart?.hospedaje?.reduce(
        (total, item) => total + Number(item?.noches),
        0
      );
      setNights(nights);
    }
  }, [dataCart]);

  useEffect(() => {
    const validateCupon = async () => {
      try {
        const cupon = await checkCupon();
        setDescount(cupon);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    validateCupon();
  }, [validatedCupon]);

  useEffect(() => {
    const codigoPaises = async () => {
      try {
        const paises = await CodigosPaises();
        setCodeCountries(paises);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    codigoPaises();
  }, []);

  useEffect(() => {
    const pasarelaActiva = async () => {
      try {
        const pasarela = await getPdp();
        setPdp(pasarela);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    pasarelaActiva();
  }, [dataCart]);

  const checkCupon = async () => {
    const buildRequest = {
      coupon_code: validatedCupon,
      total_reserva: totalReserva,
    };
    try {
      if (buildRequest.coupon_code != "" && buildRequest.total_reserva > 0) {
        const response = await validateCupon(buildRequest);
        return response;
      } else {
        return;
      }
    } catch (error) {
      throw new Error("error connection", error);
    }
  };

  const getPdp = async () => {
    try {
      const response = await getActivePDP();
      return response;
    } catch (error) {
      console.error("Error fetching rates:", error);
      return [];
    }
  };

  const CodigosPaises = async () => {
    try {
      const response = await getCodigoPaisesLada();
      return response;
    } catch (error) {
      console.error("Error fetching rates:", error);
      return [];
    }
  };

  const precioHospedajes = () => {
    if (!dataCart || !dataCart.hospedaje) return 0; // Evita errores si no hay datos

    return dataCart?.hospedaje
      ?.reduce((total, item) => total + item.totalPrices, 0)
      .toFixed(2);
  };

  const totalAdults = () => {
    if (!dataCart || !dataCart.hospedaje) return 0; // Evita errores si no hay datos

    return dataCart?.hospedaje?.reduce(
      (total, item) => total + Number(item.paxes[0].adults),
      0
    );
  };

  const totalMinors = () => {
    if (!dataCart || !dataCart.hospedaje) return 0; // Evita errores si no hay datos

    return dataCart?.hospedaje?.reduce(
      (total, item) => total + Number(item.paxes[0].minors),
      0
    );
  };
  const totalRooms = () => {
    if (!dataCart || !dataCart.hospedaje) return 0; // Evita errores si no hay datos

    return dataCart?.hospedaje?.reduce(
      (total, item) => total + Number(item.paxes[0].room),
      0
    );
  };

  const onValidateClick = (code) => {
    setValidatedCupon(code);
  };

  // Función para abrir el modal
  const handleShowModal = (e) => {
    e.stopPropagation();
    setShowModal(true);
  };
  const vposPago = async (request) => {
    let response;
    try {
      if (pdp.nombre === "OPENPAY") {
        response = await OpenpayVpos(request);
      } else if (pdp.nombre === "CONEKTA") {
        response = await ConektaVpos(request);
      }
      setUrlPDP(response);
    } catch (error) {
      throw new Error("error connection", error);
    }
  };
  const construirRequestPDP = () => {
    if (pdp.nombre === "OPENPAY") {
      requestPDP = {
        cliente: {
          nombre: formData.name,
          apellido: formData.lastName,
          telefono: formData.phone,
          email: formData.email,
        },
        cargo: {
          monto: parseFloat(totalReserva),
          concepto: "Reserva International Travel Net",
          moneda: "MXN",
          // url: "http://localhost:3000/reserva/confirmada",
          url: "https://internationaltravelnet.com.mx/reserva/confirmada",
        },
        metadatos: {
          nombreTitular: formData.name,
          apellidoTitular: formData.lastName,
          telefonoTitular: formData.phone,
          emailTitular: formData.email,
          habCount: totalRoomsData,
          montoTotal: totalReserva,
          ...formData.responsables?.reduce((acc, responsable, index) => {
            // Usamos `index + 1` para asegurar que las propiedades sean únicas
            acc[`nombreResponsableHab${index + 1}`] = responsable.name;
            acc[`apellidoResponsableHab${index + 1}`] = responsable.lastName;
            return acc;
          }, {}),
          comentario: formData.comentarios,
          hotel: dataCart?.hospedaje[0]?.nombre,
          ...(cuponCode ? { cupon: cuponCode } : ""),
        },
      };
    } else if (pdp.nombre === "CONEKTA") {
      requestPDP = {
        currency: "MXN",
        customer_info: {
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          // apellido: formData.lastName,
        },
        line_items: [
          {
            name: dataCart?.hospedaje[0]?.nombre,
            unit_price: parseFloat(totalReserva * 100),
            quantity: 1,
          },
        ],
        metadata: {
          nombreTitular: formData.name,
          apellidoTitular: formData.lastName,
          telefonoTitular: formData.phone,
          emailTitular: formData.email,
          habCount: totalRoomsData,
          montoTotal: totalReserva,
          ...formData.responsables?.reduce((acc, responsable, index) => {
            // Usamos `index + 1` para asegurar que las propiedades sean únicas
            acc[`nombreResponsableHab${index + 1}`] = responsable.name;
            acc[`apellidoResponsableHab${index + 1}`] = responsable.lastName;
            return acc;
          }, {}),
          comentario: formData.comentarios,
          hotel: dataCart?.hospedaje[0]?.nombre,
          ...(cuponCode ? { cupon: cuponCode } : ""),
        },
        checkout: {
          name: "Reserva International Travel Net",
          allowed_payment_methods: ["cash", "card", "bank_transfer"],
          type: "HostedPayment",
          success_url:
            "https://internationaltravelnet.com.mx/reserva/confirmada",
          // success_url: "http://localhost:3000/reserva/confirmada",
          failure_url:
            "https://internationaltravelnet.com.mx/reserva/confirmada/declinada",
          redirection_time: 4,
        },
      };
    }

    return requestPDP;
  };
  const handlePayment = () => {
    if (urlPDP) {
      if (pdp.nombre === "OPENPAY") {
        window.location.replace(urlPDP.url_openpay);
      } else if (pdp.nombre === "CONEKTA") {
        window.location.replace(urlPDP?.data?.payment_link_url);
      }
    }
  };

  const handleResponsableChange = (e, index, field) => {
    const value = e.target.value;

    setFormData((prevData) => {
      // Creamos una copia del array responsables (si no existe, creamos un array vacío)
      const updatedResponsables = [...(prevData.responsables || [])];

      // Si no existe el responsable en el índice, inicializamos un objeto vacío
      if (!updatedResponsables[index]) {
        updatedResponsables[index] = { name: "", lastName: "" };
      }

      // Actualizamos el campo específico dentro del responsable
      updatedResponsables[index][field] = value;

      // Retornamos el nuevo objeto formData con los responsables actualizados
      return {
        ...prevData,
        responsables: updatedResponsables,
      };
    });
  };
  const countryCodesLada = async () => {
    try {
      const response = await CodigosPaises();
      return response;
    } catch (error) {
      throw new Error("Error fetching country codes:", error);
    }
  };
  const handleSearch = async () => {
    try {
      const response = await countryCodesLada();
      const data = await response;

      const countries = data.map((country) => ({
        code: String(country.completo || ""),
      }));
      // .filter((c) => c.code.trim() !== "");

      setCodeCountries(countries);
    } catch (error) {
      console.error("Error fetching countries:", error);
      setCodeCountries([]);
    }
  };

  const handleSelectLada = (e) => {
    formData.lada = e?.[0]?.code;
  };

  return (
    <div className="container position-relative">
      <Row>
        <Col lg={12}>
          <h4
            className="p-3 fw-bolder"
            style={{ width: "85%", textAlign: "justify", fontSize: "20px" }}
          >
            Para continuar con tu reservación, es importante indicar los{" "}
            <strong style={{ color: " #d80100" }}>
              datos completos de los huéspedes
            </strong>
            , así el hotel podrá{" "}
            <strong style={{ color: " #d80100" }}>
              identificarlos al momento de tu Llegada ó Check-in
            </strong>
            .
          </h4>
        </Col>
        <Col lg={6}>
          <Row>
            <Col
              lg={12}
              style={{
                padding: "20px",
                border: "1px solid #d80100",
                backgroundColor: "#fff",
                marginBottom: "20px",
                borderRadius: "10px",
                height: "100%",
              }}
            >
              <h4 className="fw-bold" style={{ fontSize: "20px" }}>
                Titular de la reservación
              </h4>
              <p style={{ textAlign: "justify", fontSize: "14px" }}>
                Será responsable de la reservación, check in, check out y
                actividades en el alojamiento.
              </p>
              <Form onSubmit={(e) => handleSubmit(e, formValid)}>
                <Row>
                  <Col lg={6}>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label
                        style={{ textAlign: "justify", fontSize: "14px" }}
                      >
                        Nombre(s)
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        style={{ textAlign: "justify", fontSize: "14px" }}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label
                        style={{ textAlign: "justify", fontSize: "14px" }}
                      >
                        Apellido(s)
                      </Form.Label>
                      <Form.Control
                        type="text"
                        value={formData.lastName}
                        name="lastName"
                        onChange={handleChange}
                        required
                        style={{ textAlign: "justify", fontSize: "14px" }}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label
                        style={{ textAlign: "justify", fontSize: "14px" }}
                      >
                        Correo electrónico
                      </Form.Label>
                      <Form.Control
                        type="email"
                        value={formData.email}
                        name="email"
                        onChange={handleChange}
                        required
                        style={{ textAlign: "justify", fontSize: "14px" }}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Label
                      style={{ textAlign: "justify", fontSize: "14px" }}
                    >
                      Teléfono
                    </Form.Label>
                    <Form.Group
                      className="mb-3 d-flex"
                      controlId="formBasicEmail"
                    >
                      <AsyncTypeahead
                        className="w-50 me-2"
                        style={{ textAlign: "justify", fontSize: "14px" }}
                        id={"countryLada"}
                        labelKey="code" // <- debe coincidir con tus objetos
                        filterBy={["code"]}
                        minLength={2}
                        onSearch={handleSearch}
                        defaultInputValue={formData.lada}
                        onChange={(e) => handleSelectLada(e)}
                        options={codeCountries}
                        placeholder="(+) Prefijo"
                        renderMenuItemChildren={(option) => (
                          <div>
                            <span>{option.code}</span>
                          </div>
                        )}
                      />
                      <Form.Control
                        type="text"
                        value={formData.phone}
                        name="phone"
                        onChange={handleChange}
                        onInput={(e) =>
                          (e.target.value = e.target.value.replace(/\D/g, ""))
                        }
                        required
                        className="w-100"
                        maxLength={10}
                        style={{ textAlign: "justify", fontSize: "14px" }}
                      />
                    </Form.Group>
                  </Col>
                  {dataCart?.hospedaje.length > 0 && (
                    <Col lg={12}>
                      <h4 style={{ textAlign: "justify", fontSize: "14px" }}>
                        Responsables de cada habitación
                      </h4>
                      <p style={{ textAlign: "justify", fontSize: "14px" }}>
                        Será responsable de cada habitación
                      </p>
                    </Col>
                  )}
                  <Col lg={12}>
                    <Row>
                      {dataCart?.hospedaje && (
                        <>
                          {dataCart?.hospedaje?.map((item, index) => (
                            <>
                              <p
                                className="fw-bold"
                                style={{
                                  textAlign: "justify",
                                  fontSize: "20px",
                                }}
                              >
                                Responsable de la habitación {index + 1}
                              </p>
                              <Col lg={6}>
                                <Form.Group className="mb-3">
                                  <Form.Label
                                    style={{
                                      textAlign: "justify",
                                      fontSize: "14px",
                                    }}
                                  >
                                    Nombre(s)
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    name={`responsables[${index}].name`}
                                    value={formData.responsables?.[index]?.name}
                                    onChange={(e) =>
                                      handleResponsableChange(e, index, "name")
                                    }
                                    required
                                    style={{
                                      textAlign: "justify",
                                      fontSize: "14px",
                                    }}
                                  />
                                </Form.Group>
                              </Col>
                              <Col lg={6}>
                                <Form.Group className="mb-3">
                                  <Form.Label
                                    style={{
                                      textAlign: "justify",
                                      fontSize: "14px",
                                    }}
                                  >
                                    Apellido(s)
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    name={`responsables[${index}].lastName`}
                                    value={
                                      formData.responsables?.[index]?.lastName
                                    }
                                    onChange={(e) =>
                                      handleResponsableChange(
                                        e,
                                        index,
                                        "lastName"
                                      )
                                    }
                                    required
                                    style={{
                                      textAlign: "justify",
                                      fontSize: "14px",
                                    }}
                                  />
                                </Form.Group>
                              </Col>
                            </>
                          ))}
                        </>
                      )}
                    </Row>
                  </Col>
                  <Col lg={12}>
                    <h4 style={{ textAlign: "justify", fontSize: "20px" }}>
                      Comentarios adicionales
                    </h4>
                    <p style={{ textAlign: "justify", fontSize: "14px" }}>
                      Si deseas dejar algún mensaje y/o comentario al hotel,
                      puedes hacerlo a continuación.
                    </p>
                    <Form.Control
                      style={{ textAlign: "justify", fontSize: "14px" }}
                      value={formData.comentarios}
                      name="comentarios"
                      onChange={handleChange}
                      as="textarea"
                      rows={3}
                    />
                  </Col>
                  <Col
                    lg={12}
                    style={{
                      padding: "15px",
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Button
                      type="submit"
                      className="w-50 btn-blue rounded-3"
                      onClick={handleValidation}
                      style={{ fontSize: "14px" }}
                    >
                      Siguiente
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Col>
            <Col lg={12}>
              <Row>
                {validForm && (
                  <Col
                    lg={12}
                    style={{
                      padding: "20px",
                      border: "1px solid #d80100",
                      backgroundColor: "#fff",
                      marginBottom: "20px",
                      borderRadius: "10px",
                    }}
                  >
                    <h4 style={{ textAlign: "justify", fontSize: "20px" }}>
                      Realizar la reserva
                    </h4>
                    <Form>
                      <Form.Group className="d-flex my-4">
                        <Form.Check // prettier-ignore
                          type="checkbox"
                          style={{ textAlign: "justify", fontSize: "14px" }}
                        />
                        <Form.Label
                          className="ms-4 mb-0"
                          style={{ textAlign: "justify", fontSize: "14px" }}
                        >
                          He leído y acepto las{" "}
                          <Button
                            className="p-0 m-0"
                            variant="link"
                            onClick={handleShowModal}
                            style={{ fontSize: "14px" }}
                          >
                            políticas de Privacidad y Cancelación
                          </Button>
                        </Form.Label>
                        <ModalTerminos
                          openModal={showModal}
                          setOpenModal={setShowModal}
                        />
                      </Form.Group>

                      <div className="pt-3 d-flex justify-content-end">
                        <Button
                          style={{ fontSize: "14px" }}
                          className="w-50 btn-blue rounded-3"
                          onClick={handlePayment}
                          disabled={urlPDP != "" ? false : true}
                        >
                          Pagar
                        </Button>
                      </div>
                    </Form>
                  </Col>
                )}
                {dataCart?.hospedaje.length > 0 && (
                  <Col
                    lg={12}
                    style={{
                      padding: "20px",
                      border: "1px solid #d80100",
                      backgroundColor: "#fff",
                      marginBottom: "20px",
                      borderRadius: "10px",
                    }}
                    className="detalle-hospedaje-movil"
                  >
                    <h4 className="fw-bolder" style={{ fontSize: "20px" }}>
                      {dataCart?.hospedaje[0]?.nombre}
                    </h4>
                    <div>
                      <p className="fw-bolder" style={{ fontSize: "14px" }}>
                        <FaRegCalendarAlt />{" "}
                        <span className="text-secondary fw-lighter">
                          Check in:
                        </span>{" "}
                        {FormatDate(dataCart?.hospedaje[0]?.checkIn)}
                      </p>
                      <p className="fw-bolder" style={{ fontSize: "14px" }}>
                        <FaRegCalendarAlt />{" "}
                        <span className="text-secondary fw-lighter">
                          Check out:
                        </span>{" "}
                        {FormatDate(dataCart?.hospedaje[0]?.checkOut)}
                      </p>
                      <p className="fw-bolder" style={{ fontSize: "14px" }}>
                        <IoMoonOutline />{" "}
                        <span className="text-secondary fw-lighter">
                          Noches:
                        </span>{" "}
                        {dataCart?.hospedaje[0]?.noches}
                      </p>
                      <p className="fw-bolder" style={{ fontSize: "14px" }}>
                        <IoMdBed />{" "}
                        <span className="text-secondary fw-lighter">
                          Habitaciones:
                        </span>{" "}
                        {totalPax[2]}
                      </p>
                      <p className="fw-bolder" style={{ fontSize: "14px" }}>
                        <FaPerson />{" "}
                        <span className="text-secondary fw-lighter">
                          Adultos:
                        </span>{" "}
                        {totalPax[0]}
                      </p>
                      <p className="fw-bolder" style={{ fontSize: "14px" }}>
                        <FaChild />{" "}
                        <span className="text-secondary fw-lighter">
                          Menores:
                        </span>{" "}
                        {totalPax[1]}
                      </p>
                    </div>
                  </Col>
                )}
                <Accordion defaultActiveKey="0" className="p-lg-0 p-2" flush>
                  <Accordion.Item eventKey="0" className="mb-3">
                    <Accordion.Header className="text-blue">
                      <p style={{ fontSize: "20px", margin: "0px" }}>
                        Detalles de tu Hospedaje{" "}
                      </p>
                    </Accordion.Header>
                    <Accordion.Body>
                      {dataCart?.hospedaje.length > 0 && (
                        <Col
                          lg={12}
                          style={{
                            padding: "20px",
                            border: "1px solid #d80100",
                            backgroundColor: "#fff",
                            marginBottom: "20px",
                            borderRadius: "10px",
                          }}
                        >
                          <Row>
                            <h4
                              className="fw-bold"
                              style={{ fontSize: "20px" }}
                            >
                              Resumen de la reservación
                            </h4>
                            <Col lg={12}>
                              <Row>
                                {dataCart?.hospedaje?.map((item, index) => {
                                  return (
                                    <>
                                      <Col lg={6}>
                                        <h5 style={{ fontSize: "18px" }}>
                                          Detalles de la habitacion {index + 1}
                                        </h5>
                                        <p
                                          className="fw-bolder"
                                          style={{ fontSize: "14px" }}
                                        >
                                          {item.nombreHab}
                                        </p>
                                        <p
                                          className="fw-bolder"
                                          style={{ fontSize: "14px" }}
                                        >
                                          <span className="text-secondary fw-lighter">
                                            Plan de alimento:
                                          </span>{" "}
                                          {item?.boardName}
                                        </p>
                                        <p
                                          className="fw-bolder"
                                          style={{ fontSize: "14px" }}
                                        >
                                          <span className="text-secondary fw-lighter">
                                            Adultos:
                                          </span>{" "}
                                          {item.paxes[0].adults}
                                        </p>
                                        <p
                                          className="fw-bolder"
                                          style={{ fontSize: "14px" }}
                                        >
                                          <span className="text-secondary fw-lighter">
                                            Menores:
                                          </span>{" "}
                                          {item.paxes[0].minors}{" "}
                                          <span className="text-secondary fw-lighter">
                                            | edades:
                                          </span>{" "}
                                          {item.paxes[0]?.ages.length > 0
                                            ? item.paxes[0]?.ages
                                            : 0}
                                        </p>
                                      </Col>

                                      <Col lg={6}>
                                        <h5 style={{ fontSize: "18px" }}>
                                          Destino del alojamiento
                                        </h5>
                                        <p
                                          className="fw-bolder"
                                          style={{ fontSize: "14px" }}
                                        >
                                          {item.destino}
                                        </p>
                                        <p
                                          className="fw-bolder"
                                          style={{ fontSize: "14px" }}
                                        >
                                          <span className="text-secondary fw-lighter">
                                            Hotel:
                                          </span>{" "}
                                          {item.nombre}
                                        </p>
                                        <p
                                          className="fw-bolder"
                                          style={{ fontSize: "14px" }}
                                        >
                                          <span className="text-secondary fw-lighter">
                                            CheckIn:
                                          </span>{" "}
                                          {FormatDate(item.checkIn)}
                                        </p>
                                        <p
                                          className="fw-bolder"
                                          style={{ fontSize: "14px" }}
                                        >
                                          <span className="text-secondary fw-lighter">
                                            CheckOut:
                                          </span>{" "}
                                          {FormatDate(item.checkOut)}
                                        </p>
                                      </Col>
                                      <Col lg={12}>
                                        <h5 style={{ fontSize: "18px" }}>
                                          Políticas de cancelación
                                        </h5>
                                        <p style={{ fontSize: "14px" }}>
                                          A partir del{" "}
                                          <strong>
                                            {FormatCancellationPolicies(
                                              item.cancellationPolicies?.[0]
                                                ?.from
                                            )}
                                          </strong>{" "}
                                          se cobrará{" "}
                                          <strong>
                                            {Currency(
                                              item.cancellationPolicies?.[0]
                                                ?.amount
                                            )}{" "}
                                            <span style={{ fontSize: "13px" }}>
                                              MXN
                                            </span>
                                          </strong>{" "}
                                          de penalidad por cancelación. Fecha y
                                          hora calculados en base a la hora
                                          local en destino.
                                        </p>
                                      </Col>
                                      <Col
                                        lg={12}
                                        style={{
                                          borderBottom: "1px solid #d80100",
                                          marginBottom: "20px",
                                        }}
                                      >
                                        <h5 style={{ fontSize: "18px" }}>
                                          Comentarios y observaciones de tu
                                          reservación
                                        </h5>
                                        <p style={{ fontSize: "14px" }}>
                                          {item.comentario}
                                        </p>
                                      </Col>
                                    </>
                                  );
                                })}
                              </Row>
                            </Col>
                          </Row>
                        </Col>
                      )}
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col lg={4} className="ps-lg-4">
          <Row>
            <Col
              lg={12}
              style={{
                padding: "20px",
                border: "1px solid #d80100",
                backgroundColor: "#fff",
                marginBottom: "20px",
                borderRadius: "10px",
              }}
            >
              <h4 style={{ fontWeight: "bold", fontSize: "20px" }}>
                ¿Tienes un cupón?
              </h4>
              <Form className="d-flex mb-2">
                <Form.Group controlId="formBasicEmail" className="w-100">
                  <Form.Control
                    type="text"
                    onChange={(e) => setCuponCode(e.target.value)}
                    style={{ fontSize: "14px" }}
                    className="w-100"
                  />
                </Form.Group>
                <div className="ps-3">
                  <Button
                    className="btn-blue w-auto rounded-3"
                    onClick={() => onValidateClick(cuponCode)}
                    style={{ fontSize: "14px" }}
                  >
                    Validar
                  </Button>
                </div>
              </Form>
              {descount != undefined && (
                <>
                  {!descount?.valid && (
                    <span className="text-danger" style={{ fontSize: "14px" }}>
                      Cupon no valido
                    </span>
                  )}
                </>
              )}
            </Col>
            <Col
              lg={12}
              style={{
                padding: "20px",
                border: "1px solid #d80100",
                backgroundColor: "#fff",
                marginBottom: "20px",
                borderRadius: "10px",
              }}
            >
              <h4 style={{ fontWeight: "bold", fontSize: "20px" }}>
                Detalle de pago
              </h4>
              <span style={{ fontSize: "15px" }}>
                Hospedaje:{" "}
                <span className="fw-bolder">{Currency(totalHospedaje)}</span>{" "}
                <span className="fw-bolder" style={{ fontSize: "13px" }}>
                  MXN
                </span>
              </span>
              <hr
                style={{
                  color: " #d80100",
                  opacity: "1",
                  width: "100%",
                }}
              />
              <hr
                style={{
                  color: " #d80100",
                  opacity: "1",
                  width: "100%",
                }}
              />
              <p style={{ fontSize: "15px" }}>
                Total:{" "}
                <strong style={{ fontSize: "18px" }}>
                  {Currency(
                    descount?.descuento
                      ? totalReserva + descount?.descuento
                      : totalReserva
                  )}{" "}
                  <span style={{ fontSize: "13px", fontWeight: "bold" }}>
                    MXN
                  </span>
                </strong>
                {descount?.valid && (
                  <>
                    <br />
                    Descuento:{" "}
                    <strong style={{ fontSize: "18px" }}>
                      {Currency(descount?.descuento)}{" "}
                      <span style={{ fontSize: "13px" }}>MXN</span>
                    </strong>
                    <br />
                    Total con descuento:{" "}
                    <strong style={{ fontSize: "18px" }}>
                      {Currency(totalReserva)}{" "}
                      <span style={{ fontSize: "13px" }}>MXN</span>
                    </strong>
                  </>
                )}
              </p>
            </Col>
            {dataCart?.hospedaje.length > 0 && (
              <Col
                lg={12}
                style={{
                  padding: "20px",
                  border: "1px solid #d80100",
                  backgroundColor: "#fff",
                  marginBottom: "20px",
                  borderRadius: "10px",
                }}
                className="detalle-hospedaje-desktop"
              >
                <h4 className="fw-bolder" style={{ fontSize: "15px" }}>
                  {dataCart?.hospedaje[0]?.nombre}
                </h4>
                <div>
                  <p className="fw-bolder" style={{ fontSize: "15px" }}>
                    <FaRegCalendarAlt />{" "}
                    <span className="text-secondary fw-lighter">Check in:</span>{" "}
                    {FormatDate(dataCart?.hospedaje[0]?.checkIn)}
                  </p>
                  <p className="fw-bolder" style={{ fontSize: "15px" }}>
                    <FaRegCalendarAlt />{" "}
                    <span className="text-secondary fw-lighter">
                      Check out:
                    </span>{" "}
                    {FormatDate(dataCart?.hospedaje[0]?.checkOut)}
                  </p>
                  <p className="fw-bolder" style={{ fontSize: "15px" }}>
                    <IoMoonOutline />{" "}
                    <span className="text-secondary fw-lighter">Noches:</span>{" "}
                    {dataCart?.hospedaje[0]?.noches}
                  </p>
                  <p className="fw-bolder" style={{ fontSize: "15px" }}>
                    <IoMdBed />{" "}
                    <span className="text-secondary fw-lighter">
                      Habitaciones:
                    </span>{" "}
                    {totalPax[2]}
                  </p>
                  <p className="fw-bolder" style={{ fontSize: "15px" }}>
                    <FaPerson />{" "}
                    <span className="text-secondary fw-lighter">Adultos:</span>{" "}
                    {totalPax[0]}
                  </p>
                  <p className="fw-bolder" style={{ fontSize: "15px" }}>
                    <FaChild />{" "}
                    <span className="text-secondary fw-lighter">Menores:</span>{" "}
                    {totalPax[1]}
                  </p>
                </div>
              </Col>
            )}
          </Row>
        </Col>
      </Row>
    </div>
  );
};
